import React from "react";
import { Card, CardContent, Typography, Box, Divider } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DateRangeIcon from '@mui/icons-material/DateRange';
import AvatarGender from '../../../components/AvatarGender/index'

import { IPanelList } from "../../../store/ducks/panel/types";


const fontSM = ["0.8rem", "0.9rem", "1rem", "1rem", "2.5rem"];
const fontXS = ["0.6rem", "0.7rem", "0.8rem", "0.8rem", "2rem"];
const iconXS = ["0.7rem", "0.8rem", "0.9rem", "0.8rem", "2rem"];

interface PanelCardProps {
    data: IPanelList;
}

export default function PanelCard({ data }: PanelCardProps) {

    return (
        <Card
            sx={{
                borderRadius: { xs: 1, sm: 2, md: 3, lg: 4, xl: 5 },
                boxShadow: { xs: 1, sm: 2, md: 3, lg: 3, xl: 5 },
                minHeight: 80,
                display: "flex",
                flexDirection: "column",
            }}
        >
            <CardContent>
                <Typography
                    fontWeight={600}
                    color="primary"
                    fontSize={fontSM}
                    mb={1}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <AvatarGender
                        gender={data?.patient.sex_at_birth}
                        size={{
                            xs: 20, sm: 30, md: 30, lg: 40, xl: 90
                        }}
                    />
                    {data?.patient.name}
                </Typography>

                {data?.medications?.map((med: any, index: number) => (
                    <Box key={index} mb={0.7}>

                        <Typography
                            fontSize={fontXS}
                            sx={{
                                "& .label": { fontWeight: 500 },
                                "& .value": { color: "secondary.main" },
                            }}
                        >
                            <span className="label">{med.name}</span> -{" "}
                            <span className="value">
                                {med.frequency} ({med.days})
                            </span>
                        </Typography>

                        <Box display="flex" gap={1} mt={0.1}>
                            <Box display="flex" flexDirection="column">
                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <DateRangeIcon sx={{ fontSize: iconXS }} />
                                    <Typography fontSize={fontXS}>
                                        Início:{" "}
                                        <Typography
                                            component="span"
                                            fontSize={fontXS}
                                            sx={{ color: "secondary.main" }}
                                        >
                                            {new Date(med.start_date)
                                                .toLocaleString("pt-BR", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: false,
                                                })
                                                .replace(",", " -")}
                                        </Typography>
                                    </Typography>
                                </Box>

                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <DateRangeIcon sx={{ fontSize: iconXS }} />
                                    <Typography fontSize={fontXS}>
                                        Fim:{" "}
                                        <Typography
                                            component="span"
                                            fontSize={fontXS}
                                            sx={{ color: "secondary.main" }}
                                        >
                                            {new Date(med.end_date)
                                                .toLocaleString("pt-BR", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: false,
                                                })
                                                .replace(",", " -")}
                                        </Typography>
                                    </Typography>
                                </Box>
                            </Box>

                            <Divider
                                flexItem
                                orientation="vertical"
                                sx={{
                                    borderWidth: {
                                        xs: "1px", sm: "1.5px", lg: "1.5px", md: "2px",
                                    },
                                    mx: [0.5, 0.5, 0.8, 0.8, 3],
                                }}
                            />

                            <Box display="flex" flexDirection="column">
                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <AccessTimeIcon sx={{ fontSize: iconXS }} />
                                    <Typography fontSize={fontXS}>
                                        Horários
                                    </Typography>
                                </Box>

                                <Box display="flex" gap={[0.2, 0.3, 0.4, 0.6, 0.8]} flexWrap="wrap">
                                    {med.hours.map((h: string) => (
                                        <Typography
                                            key={h}
                                            fontSize={fontXS}
                                            border={1}
                                            borderColor={"secondary.main"}
                                            color="secondary.main"
                                            padding={["0px 2px", "0px 2px", "0px 4px", "0px 4px", "0px 10px",]}
                                            borderRadius={[1, 1, 1, 1, 2]}
                                            display="inline-block"
                                        >
                                            {h}
                                        </Typography>
                                    ))}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                ))}

                <Box display="flex" justifyContent="space-between" mt={0.5}>
                    <Box display="flex" flexDirection="column">
                        {[
                            { label: "SAW:", value: data?.saw },
                            { label: "Acesso:", value: data?.avp },
                            { label: "HD:", value: data?.hd },
                            { label: "Bairro:", value: data?.country },
                        ].map((item, index) => (
                            <Typography
                                key={index}
                                fontSize={fontXS}
                                sx={{
                                    "& .label": { fontWeight: 500 },
                                    "& .value": { color: "secondary.main" },
                                }}
                            >
                                <span className="label">{item.label}</span>{" "}
                                <span className="value">{item.value}</span>
                            </Typography>
                        ))}
                    </Box>

                    <Box
                        alignSelf="flex-end"
                        bgcolor="secondary.main"
                        color="white"
                        padding={["0px 2px", "0px 4px", "0px 4px", "0px 4px", "0px 20px",
                        ]}
                        borderRadius={[1, 1, 1, 1, 2]}
                        display="inline-block"
                    >
                        <Typography
                            fontWeight={500}
                            fontSize={fontXS}
                        >
                            {data?.attendance_id}
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
        </Card >
    );
}
